// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ou-0";
export var discountCodeInput = "_ou-1";